import { render, staticRenderFns } from "./IcoTime.vue?vue&type=template&id=771218c2&scoped=true"
import script from "./IcoTime.vue?vue&type=script&lang=js"
export * from "./IcoTime.vue?vue&type=script&lang=js"
import style0 from "./IcoTime.vue?vue&type=style&index=0&id=771218c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771218c2",
  null
  
)

export default component.exports